export default {
  forms: {
    title: 'Forms',
    loading: 'Loading...',
    noForms: 'No forms submitted yet.',
    submittedOn: 'Submitted on',
    backToList: 'Back to forms',
    notFound: 'Form not found.',
    errors: {
      load: 'Failed to load forms. Please try again.',
      loadOne: 'Failed to load the form. Please try again.',
    },
  },
};
